import { solutionsServiceModule } from '../../../../services/solutions-service/solutions-service';
import { firebaseServiceModule } from '../../../../../../shared/app/services/firebase/firebase';
import { appAlertComponentModule } from '../../../../../../shared/app/components/app-alert/app-alert';
import { challengeProcessHelperModule } from '../challenge-process-helper';
import { codeFileModelModule } from '../../../../../../shared/app/models/code-file';

export const advancedCodeChallengeProcessServiceModule = angular
  .module(
    'Q.routes.assessments.challenges.code-challenge.advanced-code-challenge-process-service',
    [
      codeFileModelModule,
      solutionsServiceModule,
      firebaseServiceModule,
      appAlertComponentModule,
      challengeProcessHelperModule,
    ],
  )

  .factory(
    'advancedCodeChallengeProcessService',
    function (
      solutionsService,
      Solution,
      AdvancedCodeSolutionFile,
      $q,
      $location,
      firebase,
      appAlert,
      challengeProcessHelper,
    ) {
      return {
        create,
      };

      //// functions:

      function create(challenge, assessmentResultProcess) {
        const assessmentResult = assessmentResultProcess.assessmentResult;

        const process = {
          challenge,
          beginChallenge,
          cleanupAfterSave,
          setResponse,
          logTest,
          autoRunTests: false,
          disableWebPreview: !!$location.search().disablewebpreview,
        };

        return challengeProcessHelper(process, assessmentResultProcess);

        //// functions:

        function beginChallenge() {
          return assessmentResultProcess
            .startAssessmentResult()
            .then(() => solutionsService.create(challenge, assessmentResult))
            .then(process.initSolution)
            .catch(appAlert.modelError);
        }

        function cleanupAfterSave(force) {
          // due to the way files are stored, we have to clean them up, because the IDs can get changed
          if (
            process.solution &&
            process.solution.files &&
            process.originalSolution.files
          ) {
            const keys = [
              'id',
              'access',
              'deletable',
              'directory',
              'challengeFileId',
              'includeOnTest',
              'includeOnSubmit',
              'initialLayout',
              'testGroups',
            ];
            if (force) {
              keys.push('contents');
            }
            process.solution.files.forEach((solutionFile) => {
              let originalFile = process.originalSolution.files.find(
                (a) => a.path === solutionFile.path,
              );
              if (originalFile) {
                keys.forEach((key) => {
                  solutionFile[key] = originalFile[key];
                });
              }
            });
            if (process.refreshOnFilesChanged) {
              process.refreshOnFilesChanged(force);
            }
          }
        }

        function setResponse(response) {
          firebase.set(process.firebaseRef + '/runData/response', response);
        }

        function logTest(response) {
          appAlert.clear();
          setResponse(response);
          if (assessmentResultProcess.restricted) {
            return $q.when(response).then(process._saveSuccess);
          }

          // save results back to the server
          let run = {
            // TODO: add in any other changes?
            response: response,
          };
          return process.originalSolution
            .logTest(run)
            .then(() => {
              process.fd.syncUnchanged();
              process.solution.updateScore();
              assessmentResultProcess.refreshStageStatuses();
              return response;
            })
            .then(process._saveSuccess, process._saveFail)
            .catch(
              appAlert.modelError.with({
                prefix: 'There was an error saving your results:',
              }),
            );
        }
      }
    },
  );
